module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1920@2x-cea33264ef120d4adc00f1d972cd8c71.jpg";